import { render, staticRenderFns } from "./CategoryListView.vue?vue&type=template&id=13de6800&scoped=true&"
import script from "./CategoryListView.vue?vue&type=script&lang=js&"
export * from "./CategoryListView.vue?vue&type=script&lang=js&"
import style0 from "./CategoryListView.vue?vue&type=style&index=0&id=13de6800&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13de6800",
  null
  
)

export default component.exports